import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Divider,
  Drawer,
  FormControl,
  Grow,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
  useTheme,
  CardActions,
  CardMedia,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import AppSettingsAltRoundedIcon from "@mui/icons-material/AppSettingsAltRounded";
import CompareArrowsRoundedIcon from "@mui/icons-material/CompareArrowsRounded";
import MuiTextField from "@mui/material/TextField";
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
//import { AgGridReact } from 'ag-grid-react';
//import { ColDef } from 'ag-grid-community';
import React from "react";
import moment from "moment";
import { easepick, RangePlugin, AmpPlugin } from "@easepick/bundle";
import easepickCss from "@easepick/bundle/dist/index.css?url";
import easepickDarkCss from "../easepick.css?url";
import { useMedia } from "react-use";
import "chartjs-adapter-moment";
import Annotation from "chartjs-plugin-annotation";
import {
  Chart as ChartJS,
  LinearScale,
  TimeScale,
  BarElement,
  Title,
  ChartOptions,
  ArcElement,
  LineElement,
  PointElement,
} from "chart.js";
import { Bar, Doughnut } from "react-chartjs-2";
ChartJS.register(
  LinearScale,
  TimeScale,
  Title,
  BarElement,
  ArcElement,
  LineElement,
  PointElement,
  Annotation
);
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { dashboardGet, operatorsGet } from "../../api/api";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../api/hooks";

let picker: easepick.Core | null = null;

const formatNumber = (number: number) => {
  return new Intl.NumberFormat().format(number);
};

const formatMoney = (currency: string, number: number) => {
  return !!currency && currency != "XXX"
    ? `${currency} ${new Intl.NumberFormat().format(number)}`
    : "0";
};

const formatMoneyDashIfZero = (currency: string, number: number) => {
  return !!currency && currency != "XXX"
    ? `${currency} ${new Intl.NumberFormat().format(number)}`
    : "-";
};

function PaperComponent(paperProps, ref) {
  return (
    <Grow in>
      <Paper {...paperProps} elevation={8} ref={ref} />
    </Grow>
  );
}

export const Dashboard = ({ selectedBusiness }: { selectedBusiness: any }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [selected, setSelected] = useState<any | null>(null);
  const PaperComponentForward = React.forwardRef(PaperComponent);
  const [opertator, setOperator] = useState<any>({
    name: "All operators",
    id: "0",
  });
  const comparisonOptions = [
    { name: "Compared to previous period", id: "previous" },
    { name: "Compared to previous year same period", id: "same" },
  ];
  const [comparisonId, setComparisonId] = useState<any>(
    comparisonOptions[0].id
  );

  const navigate = useNavigate();
  const { profile, isLoading: profileIsLoading } = useProfile();

  const isSuperAdmin =
    profile?.roles?.some((role) => role.type === "SUPER_ADMIN") ?? false;
  const isAdmin =
    (profile?.roles?.some((role) => role.type === "BUSINESS_ADMIN") ||
      isSuperAdmin) ??
    false;

  const hasAccess = isAdmin || isSuperAdmin;

  const [dateRange, setDateRange] = useState<{
    start: Date;
    end: Date;
  }>({
    start: moment().add(-6, "days").startOf("day").toDate(),
    end: moment().endOf("day").toDate(),
  });
  // eslint-disable-next-line sonarjs/no-duplicate-string
  const [dateRangeName, setDateRangeName] = useState("Last 7 days");
  const isDarkTheme = useMedia("(prefers-color-scheme: dark)");
  const mobileFullWidth = "calc(100vw - 32px)";

  const theme = useTheme();
  const isWide = useMedia("(min-width: 768px)");

  const {
    data: operatorsResopnse,
    isLoading: operatorsIsLoading,
    error: operatorsError,
    refetch: refetchOperators,
  } = useQuery(["operatorsGet"], operatorsGet(selectedBusiness?.id), {
    enabled: !!selectedBusiness,
    refetchOnWindowFocus: false,
  });
  const operators: any = operatorsResopnse?.data;

  const operatorOptions = [
    { name: "All operators", id: "0" },
    ...(!!operators ? operators : []),
  ];

  const dataStyle = {
    minWidth: { xs: "20%", sm: "80px" },
    minHeight: "3rem",
  };

  const valueTitleStyle = {
    fontSize: "1rem",
  };

  const valueStyle = {
    fontSize: "1.375rem",
    mb: "8px",
    color: theme.palette.secondary.main,
  };

  const formatPercentageStyle = {
    fontSize: "0.875rem",
    borderRadius: "4px",
    padding: "0px 4px",
    color: "#222",
  };

  const FormatPercentage = (value: any) => {
    return value.value == 0 ? (
      <Box sx={{ bgcolor: "#e0e0e0", ...formatPercentageStyle }}>0.0%</Box>
    ) : value.value > 0 ? (
      <Box sx={{ bgcolor: "#64dd17", ...formatPercentageStyle }}>
        +{value.value}%
      </Box>
    ) : (
      <Box sx={{ bgcolor: "#ffab91", ...formatPercentageStyle }}>
        {value.value}%
      </Box>
    );
  };
  const chartHeight = "150px"; //isWide ? '200px' : '160px';

  const pieColors = [
    theme.palette.primary.main,
    "#ccc",
    "#777",
    "#444",
    "#999",
    "#000",
    "#fff",
  ];

  const pieOptions: ChartOptions<any> = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "82%",
    color: "#fff",
    fullSize: false,
    layout: {
      autoPadding: false,
    },
    plugins: {
      legend: {
        display: false,
        position: "right" as const,
        align: "center",
        labels: {
          textAlign: "left",
          color: theme.palette.text.secondary,
          boxWidth: 8,
          boxHeight: 8,
          usePointStyle: true,
        },
      },
      title: {
        display: false,
        text: "Types",
        color: theme.palette.text.secondary,
        font: { weight: "500", size: 15 },
      },
    },
  };

  /*
  const myAnnotations = [event.preShowStartTime, event.featureStartTime].filter(
    Boolean,
  );
*/

  useEffect(() => {
    if (hasAccess) {
      picker = new easepick.create({
        element: document.getElementById("datepicker")!,
        plugins: [RangePlugin, AmpPlugin],
        css: [easepickCss, easepickDarkCss],
        zIndex: 1,
        //format: 'DD/MM/YYYY',
      });

      picker.setDateRange(dateRange.start, dateRange.end);
      picker.on("select", (e) => {
        const { start, end } = e.detail;

        setDateRange({
          start,
          end,
        });
      });

      return () => {
        picker?.destroy();
      };
    }
  }, [hasAccess]);

  const setDates = (start, end) => {
    setDateRange({
      start,
      end,
    });
    picker?.setDateRange(start, end);
  };

  const handleDateChange = (event: SelectChangeEvent) => {
    setDateRangeName(event.target.value);
    switch (event.target.value) {
      case "Today":
        setDates(
          moment().startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Yesterday":
        setDates(
          moment().add(-1, "d").startOf("day").toDate(),
          moment().add(-1, "d").endOf("day").toDate()
        );
        break;
      case "Last 7 days":
        setDates(
          moment().add(-6, "days").startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Last 14 days":
        setDates(
          moment().add(-14, "days").startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Last 28 days":
        setDates(
          moment().add(-28, "days").startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Last 30 days":
        setDates(
          moment().add(-30, "days").startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Last 90 days":
        setDates(
          moment().add(-90, "days").startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Last 180 days":
        setDates(
          moment().add(-180, "days").startOf("day").toDate(),
          moment().endOf("day").toDate()
        );
        break;
      case "Last calendar year":
        setDates(
          moment().add(-1, "year").startOf("year").toDate(),
          moment().add(-1, "year").endOf("year").toDate()
        );
        break;
    }
  };

  const CustomStatusBar = (props: any) => {
    return (
      <div className="ag-status-bar-center">
        <div className="ag-status-name-value ag-status-panel ag-status-panel-total-row-count">
          <span className="label">Total Rows</span>:&nbsp;
          <span className="ag-status-name-value-value">{props.total}</span>
        </div>
      </div>
    );
  };

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  /*
  const { data: getUserAdminOfBusinessesResponse } = useQuery(
    'getUserAdminOfBusinesses',
    getUserAdminOfBusinesses,
    {
      enabled: true,
      refetchOnWindowFocus: false,
      suspense: true,
    },
  );

  const userAdminOfBusinesses = getUserAdminOfBusinessesResponse!.data;

  const [selectedBusinessId, setSelectedBusinessId] = useState<number>(
    userAdminOfBusinesses[0]?.id,
  );
  */

  const {
    data: response,
    isLoading,
    error,
    refetch,
  } = useQuery(
    ["dashboardGet", selectedBusiness?.id, dateRange, opertator, comparisonId],
    dashboardGet(selectedBusiness?.id, dateRange, opertator.id, comparisonId),
    {
      enabled: !!selectedBusiness,
      refetchOnWindowFocus: false,
    }
  );
  const data: any = response?.data;
  // console.log('data', data);

  const dateFormat = "MMM D"; // HH:mm
  const timeFormat = "HH:mm";

  const ticksDaysFirstLast = {
    autoSkip: true,
    display: true,
    color: theme.palette.text.secondary,
    includeBounds: true,
    maxRotation: 0,
    callback: function (value: any, index: number, ticks: any) {
      if (index === 0) return moment(value).format("MMM D");
      return moment(value).format("MMM") !==
        moment(ticks[index - 1].value).format("MMM")
        ? moment(value).format("MMM D")
        : moment(value).format("D");
    },
  };

  const checkoutCountChartData: any = data
    ? {
        datasets: [
          {
            label: "Successful checkout count",
            data: Object.entries(data.checkoutCountSuccessfulByDate).map(
              ([date, count]: any) => ({
                x: date,
                y: count,
              })
            ),
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main,
            borderRadius: 6,
            borderSkipped: false,
          },
        ],
      }
    : {};

  const myAnnotations = moment();

  return (
    <>
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            refetch();
            setRightDrawerOpen(false);
          }}
        >
          <Box sx={{ width: { xs: "100vw", sm: "600px" } }}>
            <Typography
              variant="h1"
              sx={{ fontSize: "1.3em", fontWeight: 500, m: "16px 24px" }}
            >
              {!!selected ? "Edit event" : "Add event"}
            </Typography>
            <Divider />
            <Box sx={{ padding: "24px" }}>
              <Box sx={{ mb: "20px" }}>
                <Typography sx={{ fontWeight: 500, display: "inline" }}>
                  Business:{" "}
                </Typography>
                {selectedBusiness?.name}
              </Box>
              {/*
              {!!selected && (
                <Box sx={{ mb: '16px' }}>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    User:{' '}
                  </Typography>
                  {selected?.name}
                </Box>
              )}
              */}
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Deletion confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? The event will not be deleted if it has sold tickets.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                setDialogOpen(false);
                if (response) {
                  refetch();
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                refetch();
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ width: "100%", maxWidth: "1220px", margin: "0 auto 16px" }}>
        {profile && !profileIsLoading && profile.roles?.length == 0 && (
          <>
            <Box
              sx={{
                m: "50px 0",
                width: "100%",
                textAlign: "center",
              }}
            >
              <Typography variant="h4">Welcome to Spidipay</Typography>
            </Box>
            <Box
              sx={{
                mt: "16px",
                display: "grid",
                gridGap: "24px",
                gridTemplateColumns: {
                  xs: "none",
                  // eslint-disable-next-line sonarjs/no-duplicate-string
                  sm: "repeat(auto-fit,minmax(360px,1fr))",
                },
              }}
            >
              <Card>
                {/*  <CardHeader title="Hosted Payment" /> */}
                <CardMedia
                  component="img"
                  image={"/images/hosted-checkout.svg"}
                  alt="Hosted checkout"
                  sx={{ objectFit: "contain" }}
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Hosted Checkout
                  </Typography>

                  <Typography
                    variant="h3"
                    sx={{ fontSize: "1rem", mb: "16px" }}
                  >
                    Integrate Spidipay Checkout to your app or website with
                    minimal code and get paid with any payment method instantly
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    onClick={() => {
                      // eslint-disable-next-line sonarjs/no-duplicate-string
                      navigate("/documentation");
                    }}
                  >
                    Start integration <KeyboardArrowRightIcon />
                  </Button>
                </CardActions>
              </Card>

              <Card>
                <CardMedia
                  component="img"
                  image={"/images/payment-request.svg"}
                  alt="Hosted checkout"
                  sx={{ objectFit: "contain" }}
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Payment Request
                  </Typography>

                  <Typography
                    variant="h3"
                    sx={{ fontSize: "1rem", mb: "16px" }}
                  >
                    Enter the amount you want to request from your customer and
                    get paid instantly with any payment method
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    disabled
                    onClick={() => {
                      navigate("/documentation");
                    }}
                  >
                    Start using Payment Request
                    <KeyboardArrowRightIcon />
                  </Button>
                </CardActions>
              </Card>

              <Card>
                <CardMedia
                  component="img"
                  image={"/images/hosted-products.svg"}
                  alt="Hosted checkout"
                  sx={{ objectFit: "contain" }}
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Hosted Products
                  </Typography>

                  <Typography
                    variant="h3"
                    sx={{ fontSize: "1rem", mb: "16px" }}
                  >
                    Add your products to Spidipay and start selling online or
                    in-store with any payment method
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    disabled
                    onClick={() => {
                      navigate("/documentation");
                    }}
                  >
                    Start with Product Checkout
                    <KeyboardArrowRightIcon />
                  </Button>
                </CardActions>
              </Card>
            </Box>
          </>
        )}
        {!!isAdmin && (
          <>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexShrink: 0,
                  flexGrow: 0,
                  alignItems: "center",
                  gap: "8px 12px",
                  minHeight: "48px",
                  maxWidth: "100vw",
                  flexWrap: "wrap",
                  padding: "8px 0 8px",
                  mb: "6px",
                }}
              >
                <Typography
                  variant="h4"
                  component="h2"
                  sx={{
                    fontSize: "1.25rem",
                    mb: "2px",
                    width: { xs: "100%", sm: "auto" },
                  }}
                >
                  Today
                </Typography>
              </Box>
              {data && (
                <Box
                  sx={{
                    display: "grid",
                    gridGap: "24px",
                    gridTemplateColumns: {
                      xs: "none",
                      sm: "repeat(auto-fit,minmax(330px,1fr))",
                    },
                    mb: "16px",
                  }}
                >
                  {data.checkoutAmountSumByHourByCurrencyToday &&
                    Object.entries(data.checkoutAmountSumByHourByCurrencyToday)
                      .length > 0 &&
                    Object.entries(
                      data.checkoutAmountSumByHourByCurrencyToday
                    ).map(([currency, currencyData]: any) => (
                      <Card
                        sx={{
                          gridColumn: { xs: "span 1", lg: "span 2" },
                          width: "100%",
                        }}
                        key={
                          "checkoutAmountSumByHourByCurrencyToday-" + currency
                        }
                      >
                        <CardContent sx={{ width: "100%" }}>
                          <Box
                            sx={{
                              flexBasis: { xs: "100%", sm: 0 },
                              flexGrow: 1,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                // eslint-disable-next-line sonarjs/no-duplicate-string
                                gap: "32px",
                              }}
                            >
                              <Box>
                                <Typography
                                  variant="h3"
                                  sx={{ ...valueTitleStyle }}
                                >
                                  Gross volume
                                </Typography>
                                <Typography sx={valueStyle}>
                                  {formatMoney(
                                    currency,
                                    data.checkoutAmountSumByCurrencyToday[
                                      currency
                                    ]._sum
                                  )}
                                </Typography>
                              </Box>
                              {/* 
                              <Box>
                                <Typography
                                  variant="h3"
                                  sx={{ ...valueTitleStyle }}
                                >
                                  Payments
                                </Typography>
                                <Typography sx={valueStyle}>
                                  {formatNumber(
                                    data.checkoutAmountSumByCurrencyToday[
                                      currency
                                    ]._count,
                                  )}
                                </Typography>
                              </Box>
                               */}
                            </Box>
                            <Box sx={{ height: chartHeight }}>
                              <Bar
                                options={{
                                  responsive: true,
                                  maintainAspectRatio: false,
                                  plugins: {
                                    legend: {
                                      display: false,
                                      position: "right" as const,
                                    },
                                    title: {
                                      display: false,
                                      text: "Tickets",
                                      color: theme.palette.text.secondary,
                                      font: { weight: "500", size: 15 },
                                    },
                                    annotation: {
                                      annotations: [
                                        {
                                          scaleID: "x",
                                          type: "line",
                                          value: moment()
                                            //.startOf("day").add(23, "h").add(44, "m")
                                            .toISOString(),
                                          borderColor:
                                            theme.palette.text.secondary,
                                          borderWidth: 1,
                                          display: true,
                                        },
                                      ],
                                    },
                                  },

                                  scales: {
                                    y: {
                                      stacked: true,
                                      ticks: {
                                        autoSkip: true,
                                        color: theme.palette.text.secondary,
                                      },
                                      grid: {
                                        // eslint-disable-next-line sonarjs/no-duplicate-string
                                        color: "rgba(140 140 140/0.15)",
                                      },
                                      border: {
                                        display: false,
                                      },
                                    },
                                    x: {
                                      border: {
                                        display: false,
                                      },
                                      stacked: true,
                                      type: "time",
                                      time: {
                                        unit: "hour",
                                        displayFormats: {
                                          millisecond: timeFormat,
                                          second: timeFormat,
                                          minute: timeFormat,
                                          hour: timeFormat,
                                          day: timeFormat,
                                        },
                                        tooltipFormat: "L",
                                      },
                                      bounds: "ticks",
                                      min: moment()
                                        .startOf("day")
                                        .toISOString(),
                                      max: moment().endOf("day").toISOString(),
                                      ticks: {
                                        autoSkip: true,
                                        display: true,
                                        color: theme.palette.text.secondary,
                                        includeBounds: true,
                                        maxRotation: 0,
                                        callback: function (
                                          value,
                                          index,
                                          ticks
                                        ) {
                                          return moment(value).format("H");
                                        },
                                      },
                                      grid: {
                                        color: "rgba(140 140 140/0.15)",
                                        display: false,
                                      },
                                    },
                                  },
                                }}
                                data={
                                  data.checkoutAmountSumByHourByCurrencyToday[
                                    currency
                                  ]
                                    ? {
                                        datasets: [
                                          {
                                            // eslint-disable-next-line sonarjs/no-duplicate-string
                                            label: "Volume per day",
                                            data: Object.entries(
                                              data
                                                .checkoutAmountSumByHourByCurrencyToday[
                                                currency
                                              ]
                                            ).map(([date, count]: any) => ({
                                              x: date,
                                              y: count,
                                            })),
                                            borderColor:
                                              theme.palette.primary.main,
                                            backgroundColor:
                                              theme.palette.primary.main,
                                            borderRadius: 6,
                                            borderSkipped: false,
                                          },
                                        ],
                                      }
                                    : {}
                                }
                              />
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    ))}

                  <Card
                  /* 
                    sx={{
                      background: theme.palette.primary.main,
                      color: '#ffffff',
                    }}
                     */
                  >
                    <CardContent
                      sx={{
                        display: "grid",
                        gridGap: "24px 16px",
                        gridTemplateColumns: "repeat(2,1fr)",
                      }}
                    >
                      <Box sx={dataStyle}>
                        <Typography>Payments</Typography>
                        <Box sx={valueStyle}>
                          {data.checkoutAmountSumByCurrencyToday &&
                          Object.keys(data.checkoutAmountSumByCurrencyToday)
                            .length != 0
                            ? Object.entries(
                                data.checkoutAmountSumByCurrencyToday
                              ).map(([currencyName, currency]: any, index) => (
                                <Box key={currencyName}>
                                  {formatNumber(currency._count)}
                                </Box>
                              ))
                            : 0}
                        </Box>
                      </Box>
                      <Box sx={dataStyle}>
                        <Typography>Spend per payment</Typography>
                        <Box sx={valueStyle}>
                          {data.checkoutAmountSumByCurrencyToday &&
                          Object.keys(data.checkoutAmountSumByCurrencyToday)
                            .length != 0
                            ? Object.entries(
                                data.checkoutAmountSumByCurrencyToday
                              ).map(([currencyName, currency]: any, index) => (
                                <Box key={index}>
                                  {formatMoneyDashIfZero(
                                    currencyName,
                                    Math.round(currency._sum / currency._count)
                                  )}
                                </Box>
                              ))
                            : 0}
                        </Box>
                      </Box>
                      <Box sx={dataStyle}>
                        <Typography>Refunds</Typography>
                        <Box sx={valueStyle}>
                          {data.refundCountToday ? data.refundCountToday : 0}
                        </Box>
                      </Box>
                      <Box sx={dataStyle}>
                        <Typography>Refund volume</Typography>
                        <Box sx={valueStyle}>
                          {data.refundAmountSumByCurrencyToday &&
                          Object.keys(data.refundAmountSumByCurrencyToday)
                            .length != 0
                            ? Object.entries(
                                data.refundAmountSumByCurrencyToday
                              ).map(([currencyName, currency]: any, index) => (
                                <Box key={index}>
                                  {formatMoney(currencyName, currency._sum)}
                                </Box>
                              ))
                            : 0}
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              )}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexShrink: 0,
                  flexGrow: 0,
                  alignItems: "center",
                  gap: "8px 12px",
                  minHeight: "56px",
                  maxWidth: "100vw",
                  flexWrap: "wrap",
                  padding: "12px 0 8px",
                  mb: "14px",
                }}
              >
                <Typography
                  variant="h4"
                  component="h2"
                  sx={{
                    fontSize: "1.25rem",
                    mb: "1px",
                    width: { xs: "100%", sm: "auto" },
                  }}
                >
                  Reports overview
                </Typography>
                <Box className="field-with-icon" sx={{ position: "relative" }}>
                  {dateRangeName != "Custom" && (
                    <FormControl
                      sx={{
                        width: { xs: "100%", sm: "auto" },
                      }}
                    >
                      <Select
                        size="small"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={dateRangeName}
                        onChange={handleDateChange}
                        sx={{
                          width: { xs: mobileFullWidth, sm: "210px" },
                        }}
                      >
                        <MenuItem value={"Today"}>Today</MenuItem>
                        <MenuItem value={"Yesterday"}>Yesterday</MenuItem>
                        <MenuItem value={"Last 7 days"}>Last 7 days</MenuItem>
                        <MenuItem value={"Last 14 days"}>Last 14 days</MenuItem>
                        <MenuItem value={"Last 28 days"}>Last 28 days</MenuItem>
                        <MenuItem value={"Last 30 days"}>Last 30 days</MenuItem>
                        <MenuItem value={"Last 90 days"}>Last 90 days</MenuItem>
                        <MenuItem value={"Last 180 days"}>
                          Last 180 days
                        </MenuItem>
                        <MenuItem value={"Last calendar year"}>
                          Last calendar year
                        </MenuItem>
                        <MenuItem value={"Custom"}>Custom range</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  <CalendarMonthOutlinedIcon
                    className="field-icon"
                    sx={{ position: "absolute", top: "7px", left: "10px" }}
                  />
                  <Box
                    sx={{
                      display: dateRangeName == "Custom" ? "block" : "none",
                      position: "relative",
                    }}
                  >
                    <MuiTextField
                      size="small"
                      id="datepicker"
                      fullWidth
                      sx={{
                        width: { xs: mobileFullWidth, sm: "260px" },
                        display: dateRangeName == "Custom" ? "block" : "none",
                      }}
                    />
                    <ArrowDropDownIcon
                      sx={{
                        position: "absolute",
                        top: "7px",
                        right: "7px",
                        opacity: isDarkTheme ? 1 : 0.645,
                        pointerEvents: "none",
                      }}
                    />
                  </Box>
                </Box>
                <Box className="field-with-icon" sx={{ position: "relative" }}>
                  <Autocomplete
                    PaperComponent={PaperComponentForward}
                    disablePortal
                    disableClearable
                    selectOnFocus
                    clearOnBlur
                    id="venue"
                    size="small"
                    options={operatorOptions}
                    getOptionLabel={(option) => option.name}
                    defaultValue={operatorOptions[0]}
                    isOptionEqualToValue={(option: any, value: any) => {
                      return option.id === value.id;
                    }}
                    onChange={(e: any, newValue: any) => {
                      setOperator(newValue);
                    }}
                    sx={{ width: { xs: mobileFullWidth, sm: "300px" } }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                  <AppSettingsAltRoundedIcon
                    className="field-icon"
                    sx={{ position: "absolute", top: "8px", left: "10px" }}
                  />
                </Box>
                <Box className="field-with-icon" sx={{ position: "relative" }}>
                  <Select
                    size="small"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={comparisonId}
                    onChange={(e: any) => {
                      setComparisonId(e.target.value);
                    }}
                    sx={{
                      width: { xs: mobileFullWidth, sm: "320px" },
                    }}
                  >
                    {comparisonOptions.map((option) => (
                      <MenuItem value={option.id} key={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <CompareArrowsRoundedIcon
                    className="field-icon"
                    sx={{ position: "absolute", top: "8px", left: "10px" }}
                  />
                </Box>
              </Box>
            </Box>
            {!data && (
              <Box sx={{ textAlign: "center", mt: 6 }}>
                <CircularProgress />
              </Box>
            )}
            {data && (
              <>
                <Box
                  sx={{
                    display: "grid",
                    gridGap: "24px",
                    gridTemplateColumns: {
                      xs: "none",
                      sm: "repeat(auto-fit,minmax(330px,1fr))",
                    },
                  }}
                >
                  {/*                  
                  <Card
                    sx={{
                      background: theme.palette.primary.main,
                      color: '#ffffff',
                    }}
                  >
                    <CardContent
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        gap: '16px 24px ',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '16px',
                          minWidth: '45%',
                        }}
                      >
                        <Box sx={dataStyle}>
                          <Typography>Gross volume</Typography>
                          <Box sx={valueStyle}>
                            {data.successfulCheckoutAmountSumByCurrency &&
                            Object.keys(
                              data.successfulCheckoutAmountSumByCurrency,
                            ).length != 0
                              ? Object.entries(
                                  data.successfulCheckoutAmountSumByCurrency,
                                ).map(
                                  // eslint-disable-next-line sonarjs/no-identical-functions
                                  ([currencyName, currency]: any, index) => (
                                    <Box key={currencyName}>
                                      {currencyName}{' '}
                                      {formatNumber(currency._sum)}
                                    </Box>
                                  ),
                                )
                              : 0}
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={dataStyle}>
                        <Typography>Payments</Typography>
                        <Box sx={valueStyle}>
                          {data.successfulCheckoutAmountSumByCurrency &&
                          Object.keys(
                            data.successfulCheckoutAmountSumByCurrency,
                          ).length != 0
                            ? Object.entries(
                                data.successfulCheckoutAmountSumByCurrency,
                                // eslint-disable-next-line sonarjs/no-identical-functions
                              ).map(([currencyName, currency]: any, index) => (
                                <Box key={currencyName}>
                                  {formatNumber(currency._count)}
                                </Box>
                              ))
                            : 0}
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
 */}
                  {Object.entries(data.checkoutAmountSumByDateByCurrency).map(
                    ([currency, currencyData]: any) => (
                      <Card
                        sx={{
                          gridColumn: "span 1",
                          width: "100%",
                        }}
                        key={"checkoutAmountSumByDateByCurrency-" + currency}
                      >
                        <CardContent sx={{ width: "100%" }}>
                          <Box
                            sx={{
                              flexBasis: { xs: "100%", sm: 0 },
                              flexGrow: 1,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                // eslint-disable-next-line sonarjs/no-duplicate-string
                                gap: "32px",
                              }}
                            >
                              <Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    // eslint-disable-next-line sonarjs/no-duplicate-string
                                    gap: "10px",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography
                                    variant="h3"
                                    sx={{ ...valueTitleStyle }}
                                  >
                                    Gross volume
                                  </Typography>
                                  {data
                                    .changeComparedToComparisonPeriodByCurrency[
                                    currency
                                  ]?.amountChange && (
                                    <FormatPercentage
                                      value={
                                        data
                                          .changeComparedToComparisonPeriodByCurrency[
                                          currency
                                        ].amountChange
                                      }
                                    />
                                  )}
                                </Box>
                                <Typography sx={valueStyle}>
                                  {formatMoney(
                                    currency,
                                    data.successfulCheckoutAmountSumByCurrency[
                                      currency
                                    ]._sum
                                  )}
                                </Typography>
                              </Box>
                              {/* 
                              <Box>
                                <Typography
                                  variant="h3"
                                  sx={{ ...valueTitleStyle }}
                                >
                                  Paymentss
                                </Typography>
                                <Typography sx={valueStyle}>
                                  {data.successfulCheckoutAmountSumByCurrency &&
                                  Object.keys(
                                    data.successfulCheckoutAmountSumByCurrency,
                                  ).length != 0
                                    ? Object.entries(
                                        data.successfulCheckoutAmountSumByCurrency,
                                        // eslint-disable-next-line sonarjs/no-identical-functions
                                      ).map(
                                        (
                                          [currencyName, currency]: any,
                                          index,
                                        ) => (
                                          <Box key={currencyName + index}>
                                            {formatNumber(currency._count)}
                                          </Box>
                                        ),
                                      )
                                    : 0}
                                </Typography>
                              </Box>
                               */}
                            </Box>
                            <Box sx={{ height: chartHeight }}>
                              <Bar
                                options={{
                                  responsive: true,
                                  maintainAspectRatio: false,
                                  plugins: {
                                    legend: {
                                      display: false,
                                      position: "right" as const,
                                    },
                                    title: {
                                      display: false,
                                      text: "Tickets",
                                      color: theme.palette.text.secondary,
                                      font: { weight: "500", size: 15 },
                                    },
                                  },

                                  scales: {
                                    y: {
                                      stacked: true,
                                      ticks: {
                                        autoSkip: true,
                                        color: theme.palette.text.secondary,
                                      },
                                      grid: {
                                        // eslint-disable-next-line sonarjs/no-duplicate-string
                                        color: "rgba(140 140 140/0.15)",
                                      },
                                      border: {
                                        display: false,
                                      },
                                    },
                                    x: {
                                      border: {
                                        display: false,
                                      },
                                      stacked: true,
                                      type: "time",
                                      time: {
                                        unit: "day",
                                        displayFormats: {
                                          millisecond: dateFormat,
                                          second: dateFormat,
                                          minute: dateFormat,
                                          hour: dateFormat,
                                          day: dateFormat,
                                        },
                                        tooltipFormat: "L",
                                      },
                                      bounds: "ticks",
                                      min: moment(dateRange.start)
                                        .startOf("day")
                                        .toISOString(),
                                      max: moment(dateRange.end)
                                        .endOf("day")
                                        .toISOString(),
                                      ticks: ticksDaysFirstLast,
                                      grid: {
                                        color: "rgba(140 140 140/0.15)",
                                        display: false,
                                      },
                                    },
                                  },
                                }}
                                data={
                                  data.checkoutAmountSumByDateByCurrency[
                                    currency
                                  ]
                                    ? {
                                        datasets: [
                                          {
                                            label: "Volume per day",
                                            data: Object.entries(
                                              data
                                                .checkoutAmountSumByDateByCurrency[
                                                currency
                                              ]
                                            ).map(([date, count]: any) => ({
                                              x: date,
                                              y: count,
                                            })),
                                            borderColor:
                                              theme.palette.primary.main,
                                            backgroundColor:
                                              theme.palette.primary.main,
                                            borderRadius: 6,
                                            borderSkipped: false,
                                          },
                                        ],
                                      }
                                    : {}
                                }
                              />
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    )
                  )}
                  <Card
                  /*                   sx={{
                    gridColumn: { xs: 'span 1', md: 'span 2' },
                  }} */
                  >
                    <CardContent>
                      <Box
                        sx={{
                          flexBasis: { xs: "100%", sm: "0" },
                          flexGrow: 1,
                          width: "100%",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                          }}
                        >
                          <Box>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <Typography
                                variant="h3"
                                sx={{ ...valueTitleStyle }}
                              >
                                Successful payments
                              </Typography>

                              {data.paymentCountChangeComparedToComparisonPeriod && (
                                <FormatPercentage
                                  value={
                                    data.paymentCountChangeComparedToComparisonPeriod
                                  }
                                />
                              )}
                            </Box>
                            <Typography sx={valueStyle}>
                              {formatNumber(data.checkoutCountSuccessful)}
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ height: chartHeight }}>
                          <Bar
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              plugins: {
                                legend: {
                                  display: false,
                                  position: "right" as const,
                                },
                                title: {
                                  display: false,
                                  text: "Tickets",
                                  color: theme.palette.text.secondary,
                                  font: { weight: "500", size: 15 },
                                },
                              },

                              scales: {
                                y: {
                                  stacked: true,
                                  ticks: {
                                    autoSkip: true,
                                    color: theme.palette.text.secondary,
                                  },
                                  grid: {
                                    // eslint-disable-next-line sonarjs/no-duplicate-string
                                    color: "rgba(140 140 140/0.15)",
                                  },
                                  border: {
                                    display: false,
                                  },
                                },
                                x: {
                                  border: {
                                    display: false,
                                  },
                                  stacked: true,
                                  type: "time",
                                  time: {
                                    unit: "day",
                                    displayFormats: {
                                      millisecond: dateFormat,
                                      second: dateFormat,
                                      minute: dateFormat,
                                      hour: dateFormat,
                                      day: dateFormat,
                                    },
                                    tooltipFormat: "L",
                                  },
                                  bounds: "ticks",
                                  min: moment(dateRange.start)
                                    .startOf("day")
                                    .toISOString(),
                                  max: moment(dateRange.end)
                                    .endOf("day")
                                    .toISOString(),
                                  ticks: ticksDaysFirstLast,
                                  grid: {
                                    color: "rgba(140 140 140/0.15)",
                                    display: false,
                                  },
                                },
                              },
                            }}
                            data={checkoutCountChartData}
                          />
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                  {Object.entries(data.SpendPerPaymentByDateByCurrency).map(
                    ([currency, currencyData]: any) => (
                      <Card
                        sx={{
                          gridColumn: "span 1",
                          width: "100%",
                        }}
                        key={"SpendPerPaymentByDateByCurrency-" + currency}
                      >
                        <CardContent sx={{ width: "100%" }}>
                          <Box
                            sx={{
                              flexBasis: { xs: "100%", sm: 0 },
                              flexGrow: 1,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                // eslint-disable-next-line sonarjs/no-duplicate-string
                                gap: "32px",
                              }}
                            >
                              <Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "10px",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography
                                    variant="h3"
                                    sx={{ ...valueTitleStyle }}
                                  >
                                    Spend per payment
                                  </Typography>
                                  {data
                                    .changeComparedToComparisonPeriodByCurrency[
                                    currency
                                  ]?.averageChange && (
                                    <FormatPercentage
                                      value={
                                        data
                                          .changeComparedToComparisonPeriodByCurrency[
                                          currency
                                        ].averageChange
                                      }
                                    />
                                  )}
                                </Box>
                                <Typography sx={valueStyle}>
                                  {formatMoneyDashIfZero(
                                    currency,
                                    Math.round(
                                      data.SpendPerPaymentByCurrency[currency]
                                    )
                                  )}
                                </Typography>
                              </Box>
                              {/* 
                              <Box>
                                <Typography
                                  variant="h3"
                                  sx={{ ...valueTitleStyle }}
                                >
                                  Paymentss
                                </Typography>
                                <Typography sx={valueStyle}>
                                  {data.successfulCheckoutAmountSumByCurrency &&
                                  Object.keys(
                                    data.successfulCheckoutAmountSumByCurrency,
                                  ).length != 0
                                    ? Object.entries(
                                        data.successfulCheckoutAmountSumByCurrency,
                                        // eslint-disable-next-line sonarjs/no-identical-functions
                                      ).map(
                                        (
                                          [currencyName, currency]: any,
                                          index,
                                        ) => (
                                          <Box key={currencyName + index}>
                                            {formatNumber(currency._count)}
                                          </Box>
                                        ),
                                      )
                                    : 0}
                                </Typography>
                              </Box>
                               */}
                            </Box>
                            <Box sx={{ height: chartHeight }}>
                              <Bar
                                options={{
                                  responsive: true,
                                  maintainAspectRatio: false,
                                  plugins: {
                                    legend: {
                                      display: false,
                                      position: "right" as const,
                                    },
                                    title: {
                                      display: false,
                                      text: "Tickets",
                                      color: theme.palette.text.secondary,
                                      font: { weight: "500", size: 15 },
                                    },
                                  },

                                  scales: {
                                    y: {
                                      stacked: true,
                                      ticks: {
                                        autoSkip: true,
                                        color: theme.palette.text.secondary,
                                      },
                                      grid: {
                                        // eslint-disable-next-line sonarjs/no-duplicate-string
                                        color: "rgba(140 140 140/0.15)",
                                      },
                                      border: {
                                        display: false,
                                      },
                                    },
                                    x: {
                                      border: {
                                        display: false,
                                      },
                                      stacked: true,
                                      type: "time",
                                      time: {
                                        unit: "day",
                                        displayFormats: {
                                          millisecond: dateFormat,
                                          second: dateFormat,
                                          minute: dateFormat,
                                          hour: dateFormat,
                                          day: dateFormat,
                                        },
                                        tooltipFormat: "L",
                                      },
                                      bounds: "ticks",
                                      min: moment(dateRange.start)
                                        .startOf("day")
                                        .toISOString(),
                                      max: moment(dateRange.end)
                                        .endOf("day")
                                        .toISOString(),
                                      ticks: ticksDaysFirstLast,
                                      grid: {
                                        color: "rgba(140 140 140/0.15)",
                                        display: false,
                                      },
                                    },
                                  },
                                }}
                                data={
                                  data.SpendPerPaymentByDateByCurrency[currency]
                                    ? {
                                        datasets: [
                                          {
                                            label: "Volume per day",
                                            data: Object.entries(
                                              data
                                                .SpendPerPaymentByDateByCurrency[
                                                currency
                                              ]
                                            ).map(([date, count]: any) => ({
                                              x: date,
                                              y: count,
                                            })),
                                            borderColor:
                                              theme.palette.primary.main,
                                            backgroundColor:
                                              theme.palette.primary.main,
                                            borderRadius: 6,
                                            borderSkipped: false,
                                          },
                                        ],
                                      }
                                    : {}
                                }
                              />
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    )
                  )}
                  {
                    // checkout details
                  }
                  {data.checkoutCountSuccessful +
                    data.checkoutCountUnsuccessful !=
                    0 && (
                    <Card>
                      <CardContent>
                        <Typography
                          variant="h3"
                          sx={{ fontSize: "1rem", mb: "16px" }}
                        >
                          Checkout results
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "16px",
                          }}
                        >
                          <Box
                            className="circularChartContainer"
                            sx={{
                              width: isWide ? "144px" : "120px",
                              height: isWide ? "144px" : "120px",
                              position: "relative",
                            }}
                          >
                            <Typography
                              sx={{
                                width: "100%",
                                height: "100%",
                                position: "absolute",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                top: 0,
                                color: theme.palette.text.secondary,
                                pointerEvents: "none",
                                zIndex: -1,
                              }}
                            >
                              Results
                            </Typography>
                            <Box
                              sx={{
                                zIndex: 100,
                                width: "100%",
                                height: "100%",
                              }}
                            >
                              <Doughnut
                                options={pieOptions as any}
                                data={{
                                  labels: ["Successful", "Unsuccessful"],

                                  datasets: [
                                    {
                                      label: "Result",
                                      data: [
                                        data.checkoutCountSuccessful,
                                        data.checkoutCountUnsuccessful,
                                      ],

                                      backgroundColor: [
                                        theme.palette.primary.main,
                                        "#ccc",
                                        "#777",
                                        "#444",
                                        "#999",
                                        "#000",
                                        "#fff",
                                      ],
                                      borderWidth: 0,
                                    },
                                  ],
                                }}
                              />
                            </Box>
                          </Box>
                          <Box>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "16px",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "top",
                                }}
                              >
                                <Box
                                  sx={{
                                    height: "1.5rem",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      background: pieColors[0],
                                      width: "0.75rem",
                                      height: "0.75rem",
                                      // eslint-disable-next-line sonarjs/no-duplicate-string
                                      display: "block",
                                      borderRadius: "100px",
                                      mr: "6px",
                                    }}
                                  ></Box>
                                </Box>
                                <Typography
                                  color="text.secondary"
                                  sx={{ display: "inline" }}
                                >
                                  Successful: <br />
                                  {Math.round(
                                    (data.checkoutCountSuccessful * 100) /
                                      data.checkoutCountTotal
                                  )}
                                  %{" ("}
                                  {formatNumber(data.checkoutCountSuccessful)}
                                  {")"}
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "top",
                                }}
                              >
                                <Box
                                  sx={{
                                    height: "1.5rem",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      background: pieColors[1],
                                      width: "0.75rem",
                                      height: "0.75rem",
                                      display: "block",
                                      borderRadius: "100px",
                                      mr: "6px",
                                    }}
                                  ></Box>
                                </Box>
                                <Typography
                                  color="text.secondary"
                                  sx={{ display: "inline" }}
                                >
                                  Unsuccessful: <br />
                                  {Math.round(
                                    (data.checkoutCountUnsuccessful * 100) /
                                      data.checkoutCountTotal
                                  )}
                                  %{" ("}
                                  {formatNumber(data.checkoutCountUnsuccessful)}
                                  {")"}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  )}
                  {!!data.checkoutCountSuccessfulByProviderId &&
                    !!Object.keys(data.checkoutCountSuccessfulByProviderId)
                      .length && (
                      <Card>
                        <CardContent>
                          <Typography
                            variant="h3"
                            sx={{ fontSize: "1rem", mb: "16px" }}
                          >
                            Payments per method
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "16px",
                            }}
                          >
                            <Box
                              sx={{
                                width: isWide ? "144px" : "120px",
                                height: isWide ? "144px" : "120px",
                                position: "relative",
                              }}
                            >
                              <Typography
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  position: "absolute",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  top: 0,
                                  color: theme.palette.text.secondary,
                                  pointerEvents: "none",
                                  zIndex: -1,
                                }}
                              >
                                Methods
                              </Typography>
                              <Box
                                sx={{
                                  zIndex: 100,
                                  width: "100%",
                                  height: "100%",
                                }}
                              >
                                <Doughnut
                                  options={pieOptions as any}
                                  data={{
                                    labels: Object.entries(
                                      data.checkoutCountSuccessfulByProviderId
                                    ).map(
                                      ([methodName, method]: any) => methodName
                                    ),

                                    datasets: [
                                      {
                                        label: "Ticket types",
                                        data: Object.entries(
                                          data.checkoutCountSuccessfulByProviderId
                                        ).map(
                                          ([methodName, method]: any) =>
                                            method._count
                                        ),

                                        backgroundColor: [
                                          theme.palette.primary.main,
                                          "#ccc",
                                          "#777",
                                          "#444",
                                          "#999",
                                          "#000",
                                          "#fff",
                                        ],
                                        borderWidth: 0,
                                      },
                                    ],
                                  }}
                                />
                              </Box>
                            </Box>
                            <Box>
                              <Box>
                                {!!data.checkoutCountSuccessfulByProviderId &&
                                  Object.entries(
                                    data.checkoutCountSuccessfulByProviderId
                                  ).map(([methodName, method]: any, index) => (
                                    <Box key={methodName}>
                                      <Box
                                        sx={{
                                          background: pieColors[index],
                                          width: "0.75rem",
                                          height: "0.75rem",
                                          display: "inline-block",
                                          borderRadius: "100px",
                                          mr: "6px",
                                        }}
                                      ></Box>
                                      <Typography
                                        color="text.secondary"
                                        sx={{
                                          display: "inline",
                                        }}
                                      >
                                        {method.name || methodName}:{" "}
                                        {formatNumber(method._count)}
                                      </Typography>
                                    </Box>
                                  ))}
                              </Box>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    )}
                  {!!data.checkoutCountUnsuccessfulByProviderId &&
                    !!Object.keys(data.checkoutCountUnsuccessfulByProviderId)
                      .length && (
                      <Card>
                        <CardContent>
                          <Typography
                            variant="h3"
                            sx={{ fontSize: "1rem", mb: "16px" }}
                          >
                            Unsuccessful per payment method
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "16px",
                            }}
                          >
                            <Box
                              sx={{
                                width: isWide ? "144px" : "120px",
                                height: isWide ? "144px" : "120px",
                                position: "relative",
                              }}
                            >
                              <Typography
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  position: "absolute",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  top: 0,
                                  color: theme.palette.text.secondary,
                                  pointerEvents: "none",
                                  zIndex: -1,
                                }}
                              >
                                Methods
                              </Typography>
                              <Box
                                sx={{
                                  zIndex: 100,
                                  width: "100%",
                                  height: "100%",
                                }}
                              >
                                <Doughnut
                                  options={pieOptions as any}
                                  data={{
                                    labels: Object.entries(
                                      data.checkoutCountUnsuccessfulByProviderId
                                    ).map(
                                      ([methodName, method]: any) => methodName
                                    ),

                                    datasets: [
                                      {
                                        label: "Ticket types",
                                        data: Object.entries(
                                          data.checkoutCountUnsuccessfulByProviderId
                                        ).map(
                                          ([methodName, method]: any) =>
                                            method._count
                                        ),

                                        backgroundColor: [
                                          theme.palette.primary.main,
                                          "#ccc",
                                          "#777",
                                          "#444",
                                          "#999",
                                          "#000",
                                          "#fff",
                                        ],
                                        borderWidth: 0,
                                      },
                                    ],
                                  }}
                                />
                              </Box>
                            </Box>
                            <Box>
                              <Box>
                                {!!data.checkoutCountUnsuccessfulByProviderId &&
                                  Object.entries(
                                    data.checkoutCountUnsuccessfulByProviderId
                                    // eslint-disable-next-line sonarjs/no-identical-functions
                                  ).map(([methodName, method]: any, index) => (
                                    <Box key={methodName}>
                                      <Box
                                        sx={{
                                          background: pieColors[index],
                                          width: "0.75rem",
                                          height: "0.75rem",
                                          display: "inline-block",
                                          borderRadius: "100px",
                                          mr: "6px",
                                        }}
                                      ></Box>
                                      <Typography
                                        color="text.secondary"
                                        sx={{
                                          display: "inline",
                                        }}
                                      >
                                        {method.name || methodName}:{" "}
                                        {formatNumber(method._count)}
                                      </Typography>
                                    </Box>
                                  ))}
                              </Box>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    )}
                </Box>
              </>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default Dashboard;
